<ui-auth-layout>
  <div class="auth-heading">
    <h1 class="auth-heading__title">{{ 'authentication.reset_password' | translate }}</h1>
    <p class="auth-heading__subtitle">{{ 'authentication.reset_password_subtitle' | translate }}</p>
  </div>

  <form
    class="auth-form"
    [formGroup]="resetPasswordForm"
    (ngSubmit)="requestPasswordReset()"
    (keydown.enter)="onEnterKey($event)"
  >
    <!-- Tenant picker. Same visibility contract as before: local, QA and
         pre-prod hosts only, never a production domain — see `showDBOptions`. -->
    <ui-form-field
      *ngIf="showDBOptions"
      [id]="'database'"
      type="select"
      formControlName="database"
      [label]="'authentication.environment' | translate"
      [options]="databaseOptions"
      [fullWidth]="true"
    ></ui-form-field>

    <ui-form-field
      [id]="'email'"
      type="email"
      formControlName="email"
      autocomplete="email"
      [label]="'authentication.email' | translate"
      [placeholder]="'authentication.email_placeholder' | translate"
      [errorMessages]="{
        required: 'authentication.required_email' | translate,
        email: 'authentication.invalid_email' | translate
      }"
      [fullWidth]="true"
    ></ui-form-field>

    <div class="auth-form__actions">
      <ui-button
        type="primary"
        [label]="'authentication.send_reset_link' | translate"
        [fullWidth]="true"
      ></ui-button>

      <a class="auth-link" [routerLink]="['/login']">
        <ui-svg-icon svgIcon="chevron-right-cc" size="small" [rotated]="true"></ui-svg-icon>
        {{ 'authentication.back_to_login' | translate }}
      </a>
    </div>
  </form>

  <div class="auth-note">
    <span class="auth-note__icon">
      <ui-svg-icon svgIcon="mail-cc" size="medium"></ui-svg-icon>
    </span>
    <p class="auth-note__text">{{ 'authentication.reset_password_hint' | translate }}</p>
  </div>
</ui-auth-layout>
